import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { Button } from "../components/ui/button";
import { UpgradeDialog } from "../components/UpgradeDialog";
import { useAuth } from "../context/AuthContext";

const PARAGRAPHS = [
  "Most quoting tools guess. We don’t. You describe the job in plain words — or just talk it through — and BidMark searches real prices across the web. You get a low, typical, and high range for the work, each tied to actual sources, so you know where the numbers come from.",
  "From there you can build a clean, professional quote, add your company and customer details, and either download it as a PDF or send it immediately from BidMark Quotes. When the job is done, you can turn any quote into an invoice and send that the same way. You can also search for real leads that match your business, right beside the quote.",
  "Whether you’re a tradesperson, service provider, or almost any other kind of business, the goal is simple: spend less time second-guessing prices and more time sending quotes that look solid and close work.",
];

export default function AboutPage() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [upgradeOpen, setUpgradeOpen] = useState(false);
  return (
    <div className="min-h-screen flex flex-col">
      <Header onUpgrade={() => setUpgradeOpen(true)} />
      <main className="flex-1 max-w-3xl mx-auto w-full px-4 sm:px-6 lg:px-8 py-12">
        <article data-testid="about-content" className="bg-white/80 backdrop-blur-md border border-[#E2DCD2] rounded-2xl shadow-sm p-6 sm:p-10">
          <div className="text-xs font-semibold uppercase tracking-widest text-[#A6844A]">About</div>
          <h1 className="mt-2 font-serif text-4xl sm:text-5xl text-[#1B3A4B] leading-tight">BidMark Quotes helps businesses write quotes they can stand behind.</h1>
          <div className="mt-8 space-y-5 text-base text-[#1C1915] leading-relaxed">
            {PARAGRAPHS.map((p, i) => <p key={i}>{p}</p>)}
          </div>
          <p className="mt-8 font-serif text-xl italic text-[#1B3A4B] border-l-4 border-[#A6844A] pl-4">Built for people who do the work, not for people who just talk about it.</p>
          <Button data-testid="about-cta" onClick={() => navigate(user ? "/" : "/register")} className="mt-8 rounded-full bg-[#A6844A] hover:bg-[#8f6f3b] text-white h-11 px-6">
            {user ? "Build a quote" : "Start free"}
          </Button>
        </article>
      </main>
      <Footer />
      <UpgradeDialog open={upgradeOpen} onOpenChange={setUpgradeOpen} />
    </div>
  );
}
